<div class="p-6">
  <!-- Toast notifications -->
  <p-toast position="top-right"></p-toast>
  
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-white mb-2">
      {{ 'community.title' | translate }}
    </h1>
    <p class="text-gray-400">
      {{ 'community.subtitle' | translate }}
    </p>
  </div>

  <div class="max-w-4xl">
    <p-card>
      <ng-template pTemplate="content">
        <form [formGroup]="communityForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
          
          <!-- Twitter -->
          <div class="flex flex-col gap-2">
            <label for="twitter" class="font-medium flex items-center gap-2">
              <i class="pi pi-twitter text-blue-500"></i>
              {{ 'community.twitter' | translate }}
            </label>
            @if (loading()) {
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
              <input
                id="twitter"
                type="url"
                pInputText
                [formControl]="twitterControl"
                [placeholder]="'community.twitterPlaceholder' | translate"
                class="w-full"
              />
              @if (twitterControl.invalid && twitterControl.touched) {
                <p-message severity="error">
                  {{ getTwitterErrorMessage() }}
                </p-message>
              }
            }
          </div>

          <!-- Facebook -->
          <div class="flex flex-col gap-2">
            <label for="facebook" class="font-medium flex items-center gap-2">
              <i class="pi pi-facebook text-blue-600"></i>
              {{ 'community.facebook' | translate }}
            </label>
            @if (loading()) {
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
              <input
                id="facebook"
                type="url"
                pInputText
                [formControl]="facebookControl"
                [placeholder]="'community.facebookPlaceholder' | translate"
                class="w-full"
              />
              @if (facebookControl.invalid && facebookControl.touched) {
                <p-message severity="error">
                  {{ getFacebookErrorMessage() }}
                </p-message>
              }
            }
          </div>

          <!-- Instagram -->
          <div class="flex flex-col gap-2">
            <label for="instagram" class="font-medium flex items-center gap-2">
              <i class="pi pi-instagram text-pink-500"></i>
              {{ 'community.instagram' | translate }}
            </label>
            @if (loading()) {
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
              <input
                id="instagram"
                type="url"
                pInputText
                [formControl]="instagramControl"
                [placeholder]="'community.instagramPlaceholder' | translate"
                class="w-full"
              />
              @if (instagramControl.invalid && instagramControl.touched) {
                <p-message severity="error">
                  {{ getInstagramErrorMessage() }}
                </p-message>
              }
            }
          </div>

          <!-- Discord -->
          <div class="flex flex-col gap-2">
            <label for="discord" class="font-medium flex items-center gap-2">
              <i class="pi pi-discord text-indigo-500"></i>
              {{ 'community.discord' | translate }}
            </label>
            @if (loading()) {
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
              <input
                id="discord"
                type="url"
                pInputText
                [formControl]="discordControl"
                [placeholder]="'community.discordPlaceholder' | translate"
                class="w-full"
              />
              @if (discordControl.invalid && discordControl.touched) {
                <p-message severity="error">
                  {{ getDiscordErrorMessage() }}
                </p-message>
              }
            }
          </div>

          <!-- Telegram -->
          <div class="flex flex-col gap-2">
            <label for="telegram" class="font-medium flex items-center gap-2">
              <i class="pi pi-send text-blue-400"></i>
              {{ 'community.telegram' | translate }}
            </label>
            @if (loading()) {
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
              <input
                id="telegram"
                type="url"
                pInputText
                [formControl]="telegramControl"
                [placeholder]="'community.telegramPlaceholder' | translate"
                class="w-full"
              />
              @if (telegramControl.invalid && telegramControl.touched) {
                <p-message severity="error">
                  {{ getTelegramErrorMessage() }}
                </p-message>
              }
            }
          </div>

          <!-- LinkedIn -->
          <div class="flex flex-col gap-2">
            <label for="linkedin" class="font-medium flex items-center gap-2">
              <i class="pi pi-linkedin text-blue-700"></i>
              {{ 'community.linkedin' | translate }}
            </label>
            @if (loading()) {
              <p-skeleton width="100%" height="2.5rem"></p-skeleton>
            } @else {
              <input
                id="linkedin"
                type="url"
                pInputText
                [formControl]="linkedinControl"
                [placeholder]="'community.linkedinPlaceholder' | translate"
                class="w-full"
              />
              @if (linkedinControl.invalid && linkedinControl.touched) {
                <p-message severity="error">
                  {{ getLinkedinErrorMessage() }}
                </p-message>
              }
            }
          </div>

          <!-- Save Button -->
          <div class="flex justify-end pt-4">
            @if (loading()) {
              <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
            } @else {
              <p-button
                type="submit"
                [label]="submitting() ? ('community.saving' | translate) : ('community.save' | translate)"
                [icon]="submitting() ? 'pi pi-spin pi-spinner' : 'pi pi-save'"
                [disabled]="communityForm.invalid || submitting()"
                [loading]="submitting()"
                severity="success"
                class="min-w-32">
              </p-button>
            }
          </div>
        </form>
      </ng-template>
    </p-card>
  </div>
</div>